import { motion } from "framer-motion";
import { useState } from "react";
import { FaClock, FaEnvelope, FaMapMarkerAlt, FaPhoneAlt } from "react-icons/fa";
import { Link } from "react-router-dom";
import herobg from "../assets/contacthero.webp";
import ContactMap from "../components/ContactMap";


const contacts = [
  {
    id: 1,
    icon: <FaMapMarkerAlt className="text-primary text-4xl" />,
    title: "Locations",
    detail: (
      <ul className="text-sm text-gray-500 space-y-1">
        <li>Mogha, Goba, Dar es Salaam, Tanzania</li>
        <li>Mtumba, Dodoma, Tanzania</li>
        <li>mbalizi bus stand, Mbeya, Tanzania</li>
      </ul>
    ),
  },
  {
    id: 2,
    icon: <FaPhoneAlt className="text-primary text-4xl" />,
    title: "Phone",
    detail: "+255 715 292 952",
  },
  {
    id: 3,
    icon: <FaEnvelope className="text-primary text-4xl" />,
    title: "Email",
    detail: "info@jighuluke.co.tz",
  },
  {
    id: 4,
    icon: <FaClock className="text-primary text-4xl" />,
    title: "Business Hours",
    detail: (
      <ul className="text-sm text-gray-500 space-y-1">
        <li>Monday - Saturday</li>
        <li>8am - 5pm</li>

      </ul>
    ),
  },

];

function Contact() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [message, setMessage] = useState("");
  const [status, setStatus] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus(null);

    const formData = new FormData();
    formData.append("name", name);
    formData.append("email", email);
    formData.append("phone", phone);
    formData.append("message", message);

    try {
      const response = await fetch("/send_mail.php", {
        method: "POST",
        body: formData,
      });

      const result = await response.json();

      if (response.ok) {
        setStatus({ type: "success", message: result.message });
        setName("");
        setEmail("");
        setPhone("");
        setMessage("");
      } else {
        setStatus({ type: "error", message: result.message });
      }
    } catch (err) {
      setStatus({ type: "error", message: "An unexpected error occurred." });
    }
  };

  const newLocal = "w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary";

  return (
    <div>
      {/* Hero Section */}
      <section
        className="relative w-full h-[30vh] md:h-[40vh] bg-cover bg-center"
        style={{ backgroundImage: `url(${herobg})` }}
      >
        <div className="absolute inset-0 bg-black bg-opacity-75"></div>
        <div className="relative z-10 flex flex-col items-start justify-center h-full px-6 md:px-12 max-w-6xl mx-auto text-white">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">Contact Us</h1>
          <div className="flex items-center text-sm md:text-base space-x-2 text-gray-200">
            <Link to="/" className="hover:text-white cursor-pointer">
              Home
            </Link>
            <span>/</span>
            <Link
              to="/contact"
              className="text-gray-300 underline hover:text-white cursor-pointer"
            >
              Contact Us
            </Link>
          </div>
        </div>
      </section>


      <div className="max-w-6xl mx-auto px-6 py-16 grid grid-cols-1 lg:grid-cols-3 gap-12">
        <div className="lg:col-span-2 px-6">
          <div>
            <motion.h2
              initial={{ opacity: 0, y: 40 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
              className="text-3xl  font-bold text-center text-gray-800"
            >
              Get Us In Touch
            </motion.h2>
            <p className="text-center">Reach out to us through any of the contact details below.</p>
          </div>
          <motion.form
            onSubmit={handleSubmit}
            initial={{ opacity: 0, scale: 0.95 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.6 }}
            className="bg-white p-8 rounded-sm shadow-lg space-y-6"
          >
            <div>
              <label className="block text-sm font-medium text-gray-600 mb-2">Your Name</label>
              <input
                type="text"
                name="name"
                placeholder="Enter your name"
                value={name}
                onChange={(e) => setName(e.target.value)}
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary"
                required
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-600 mb-2">Your Email</label>
              <input
                type="email"
                name="email"
                placeholder="Enter your email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary"
                required
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-600 mb-2">Your Phone</label>
              <input
                type="tel"
                name="phone"
                placeholder="Enter your phone number"
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-600 mb-2">Your Message</label>
              <textarea
                name="message"
                rows="5"
                placeholder="Type your message..."
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                className={newLocal}
                required
              />
            </div>

            <motion.button
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              type="submit"
              className="w-full bg-primary text-white py-3 rounded-lg font-semibold shadow-md hover:bg-primary/90 transition duration-300"
            >
              Send Message
            </motion.button>

            {status && (
              <p className={`text-center mt-4 ${status.type === "success" ? "text-green-600" : "text-red-600"}`}>
                {status.message}
              </p>
            )}
          </motion.form>

        </div>

        <div className="lg:col-span-1 bg-gray-50 rounded-sm shadow-lg p-5 space-y-8">
          {contacts.map((item, index) => (
            <motion.div
              key={item.id}
              initial={{ opacity: 0, y: 50 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.2 }}
              whileHover={{ scale: 1.02 }}
              className="flex gap-4 items-start border-b pb-6 last:border-none"
            >
              <div className="w-12 h-12 flex items-center justify-center bg-primary/10 rounded-xl">
                {item.icon}
              </div>

              <div>
                <h4 className="font-semibold text-gray-700 text-lg mb-1">{item.title}</h4>
                <div className="text-sm text-gray-500">{item.detail}</div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>

      <motion.div
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.6 }}
        className="rounded-sm overflow-hidden shadow-lg"
      >
        <ContactMap />
      </motion.div>
    </div>
  );
}

export default Contact;
